import styled from 'styled-components';

export const TableCalcStyle = styled.table`
  th,
  td {
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  p,
  .UnitValueInput {
    width: 90%;
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    padding: 2px;
    margin: 3px 0 0 0;
    text-align: right;
  }
  .Total {
    width: 100px;
  }
`;

export const WrapperTables = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
`;
